import HeroSection from '../../sections/HeroSection/HeroSection';
import { ThemeProvider } from 'styled-components';
import theme from '../../global/theme';
import CounterSection from '../../sections/CounterSection/CounterSection';
import MigrationSection from '../../sections/MigrationSection/MigrationSection';
import ContactSection from '../../sections/ContactSection/ContactSection';
import CaseStudySection from '../../sections/CaseStudySection/CaseStudySection';
import { GlobalStyle } from '../../global/global';
import CarouselSectionWithImages from '../../sections/CarouselSecitionWithImages/CarouselSectionWithImages';
import ContentImage from '../../sections/ContentImageSection/ContentImageSection';
import LogotypeBar from '../../sections/LogotypeBar/LogotypeBar';
import StyledButton from '../../components/Button/Button';

import { Box, Flex, Text, Image, Heading, Hide } from '@chakra-ui/react';
import TabsSection from '../../sections/TabsSection/TabsSection';
import SubscriptionSection from '../../sections/SubscriptionSection/SubscriptionSection';
import PromoBar from '../../sections/PromoBar/PromoBar';
import SectionWithPlusTick from '../../sections/SectionWithPlusTick/SectionWithPlusTick';
import { StyledHeading, StyledHighlight } from '../../sections/CalltoActionSection/styles';
import FormSection from '../../sections/FormSection/FormSection';
import React, { useEffect } from 'react';
interface Props {}

const image = {
    url: 'https://www.idosell.com/panel/file-gate.php?id=291884&ext=.webp',
    alt: 'Zdjęcie wyróżniające w hero - strona oferty',
};

export default function OfferPage(props: Props) {
    return (
        <ThemeProvider theme={theme}>
            <GlobalStyle $whiteColor />
            <HeroSection
                title="Wybierz platformę e&#8209;commerce, która pozwoli ci osiągnąć maksymalne zyski ze sprzedaży"
                image={image}
                buttons={[
                    {
                        title: 'Zamów sklep',
                        href: 'https://www.idosell.com/pl/abonamenty/',
                        variant: 'default',
                    },
                    {
                        title: 'Umów się na spotkanie',
                        href: 'https://eu1.hubs.ly/H08swyQ0',
                        variant: 'outline-reverted',
                    },
                ]}
            />
            <div className="homepage containerIdosellPages">
                <Box
                    my={{
                        base: 16,
                        md: 20,
                        xl: 24,
                    }}
                    display={'flex'}
                    flexDirection={'column'}
                    gap={{
                        base: 20,
                        md: 24,
                    }}
                    position={'relative'}
                    _before={{
                        base: {
                            content: '""',
                            position: 'absolute',
                            height: 'calc(100% + 8rem)',
                            top: '-4rem',
                            width: '100vw',
                            left: '-50vw',
                            marginLeft: '50%',
                            zIndex: -2,
                            backgroundColor: 'rgba(238, 238, 238, 1)',
                        },
                        md: {
                            height: 'calc(100% + 10rem) !important',
                            top: '-5rem !important',
                        },
                        lg: {
                            display: 'none',
                        },
                    }}
                >
                    <FormSection
                        sectionTitle="Wszystko, czego potrzebujesz do sprzedaży online, jest w jednym miejscu"
                        sectionSubtitle="Porozmawiajmy o potrzebach Twojego biznesu i razem rozwińmy Twoją sprzedaż"
                        region="eu1"
                        portalId="26134891"
                        formId="b888235f-8503-473a-a0a9-5b41f1ebeb55"
                    />
                </Box>
                <LogotypeBar
                    logos={[
                        {
                            url: 'https://www.iai-system.com/panel/file-gate.php?id=287742&ext=.svg',
                            alt: 'Logo Anna Lewandowska',
                        },
                        {
                            url: 'https://www.iai-system.com/panel/file-gate.php?id=298446&ext=.svg',
                            alt: 'Logo babyhit',
                        },
                        {
                            url: 'https://www.iai-system.com/panel/file-gate.php?id=287744&ext=.svg',
                            alt: 'Logo Denley',
                        },
                        {
                            url: 'https://www.iai-system.com/panel/file-gate.php?id=287721&ext=.svg',
                            alt: 'Logo Minti',
                        },
                        {
                            url: 'https://www.iai-system.com/panel/file-gate.php?id=298447&ext=.svg',
                            alt: 'Logo zoo art',
                        },
                        {
                            url: 'https://www.iai-system.com/panel/file-gate.php?id=287745&ext=.svg',
                            alt: 'Logo Paese',
                        },
                        {
                            url: 'https://www.iai-system.com/panel/file-gate.php?id=287739&ext=.svg',
                            alt: 'Logo eZebra',
                        },
                    ]}
                />
                <Flex gap={16} alignItems={'center'} py={10}>
                    <Hide below="lg">
                        <Box
                            display={'flex'}
                            justifyContent={'center'}
                            alignItems={'center'}
                            minW={'25%'}
                        >
                            <Image src="https://www.iai-system.com/panel/file-gate.php?id=298407&ext=.jpg" />
                        </Box>
                    </Hide>
                    <Flex flexDirection={'column'}>
                        <StyledHeading style={{ textAlign: 'left' }}>
                            IdoSell to SaaS bez ograniczeń
                        </StyledHeading>
                        <Text
                            fontSize={{
                                base: 'md',
                                md: 'lg',
                            }}
                            mt={5}
                        >
                            SaaS (Software as a Service) oznacza oprogramowanie jako usługę. W
                            IdoSell otrzymujesz gotowe rozwiązanie i nie musisz samodzielnie
                            utrzymywać całego systemu sklepowego, czy martwić się o kwestie
                            techniczne. SaaS pozwala Ci skupić się na sprzedaży i promocji swojego
                            sklepu.
                        </Text>
                        <Text
                            fontSize={{
                                base: 'md',
                                md: 'lg',
                            }}
                            mt={2}
                        >
                            Dodatkowo udostępniamy specjalne zaawansowane narzędzia dla developerów
                            w ramach idei Open SaaS™. Dają one możliwość osadzania własnych
                            integracji w zamkniętym systemie SaaS, za którego jakość odpowiadamy
                        </Text>
                    </Flex>
                </Flex>
                <CounterSection
                    py={4}
                    title="Dlaczego IdoSell?"
                    subtitle="Obsługujemy firmy każdej wielkości i z każdej branży. Wiemy, jak łączyć stabilność, nowości, wsparcie, skalowalność i efektywność kosztową.
IdoSell to nie tylko oprogramowanie sklepu internetowego, to cała gama rozwiązań, w których możesz czuć się swobodnie."
                    layout="2x3"
                    items={[
                        {
                            mainNumber: '>16,5',
                            additionalText: ' mld zł',
                            text: 'sumaryczna wartość transakcji rocznie (GMV)',
                        },
                        {
                            mainNumber: '60',
                            additionalText: ' mln',
                            text: 'transakcji rocznie',
                        },
                        {
                            mainNumber: '~8',
                            additionalText: ' tys.',
                            text: 'sklepów',
                        },
                        {
                            mainNumber: '>20',
                            additionalText: ' %',
                            text: 'udział transakcji cross border',
                        },
                        {
                            mainNumber: '99,99',
                            additionalText: ' %',
                            text: 'SLA dostępności platformy',
                        },
                        {
                            mainNumber: '25',
                            additionalText: ' lat',
                            text: 'w branży',
                        },
                    ]}
                    data="string"
                    _before={{
                        content: '""',
                        position: 'absolute',
                        height: '100%',
                        top: 0,
                        width: '100vw',
                        marginLeft: '50%',
                        left: '-50vw',
                        zIndex: -2,
                        backgroundColor: 'rgba(238, 238, 238, 1)',
                    }}
                    position={'relative'}
                    mt={10}
                />
                <Flex
                    direction={'column'}
                    // justifyContent={'center'}
                    // alignItems={'center'}
                    pt={16}
                    // pb={8}
                >
                    <StyledHeading>Rozwijaj biznes i sprzedawaj więcej z IdoSell</StyledHeading>
                    <StyledHighlight $style={'normal'}>
                        Sprawdź dla kogo są nasze rozwiązania
                    </StyledHighlight>
                    <Flex
                        flexWrap={'wrap'}
                        gap={{
                            base: 4,
                            lg: 0,
                        }}
                        mt={7}
                        justifyContent={'space-between'}
                    >
                        <Flex
                            direction={'column'}
                            justifyContent={'space-between'}
                            backgroundColor={'#EEE'}
                            px={{
                                base: 8,
                                md: 4,
                            }}
                            py={8}
                            minH={{ lg: '350px' }}
                            w={{
                                base: '100%',
                                lg: '24%',
                            }}
                        >
                            <Box>
                                <Text
                                    fontWeight={'600'}
                                    fontSize={'lg'}
                                    // borderBottom={'3px solid black'}
                                    position={'relative'}
                                    _after={{
                                        position: 'absolute',
                                        height: '3px',
                                        width: '40px',
                                        content: '""',
                                        bottom: '-10px',
                                        left: 0,
                                        background: 'black',
                                    }}
                                >
                                    Przenieś sklep
                                </Text>
                                <Text mt={8} mb={{ base: 6, lg: 0 }}>
                                    Sprawdź jak sprawnie przeprowadzić migrację do IdoSell
                                </Text>
                            </Box>
                            <StyledButton
                                href="https://eu1.hubs.ly/H08swyQ0"
                                style="default"
                                target="_blank"
                            >
                                Przenoszę sklep
                            </StyledButton>
                        </Flex>
                        {/* --- */}
                        <Flex
                            direction={'column'}
                            justifyContent={'space-between'}
                            backgroundColor={'#EEE'}
                            px={{
                                base: 8,
                                md: 4,
                            }}
                            py={8}
                            minH={{ lg: '350px' }}
                            w={{
                                base: '100%',
                                lg: '24%',
                            }}
                        >
                            <Box>
                                <Text
                                    fontWeight={'600'}
                                    fontSize={'lg'}
                                    // borderBottom={'3px solid black'}
                                    position={'relative'}
                                    _after={{
                                        position: 'absolute',
                                        height: '3px',
                                        width: '40px',
                                        content: '""',
                                        bottom: '-10px',
                                        left: 0,
                                        background: 'black',
                                    }}
                                >
                                    Rozwijaj swój brand
                                </Text>
                                <Text mt={8} mb={{ base: 6, lg: 0 }}>
                                    Dowiedz się jak skutecznie rozwijać swój brand z nami
                                </Text>
                            </Box>
                            <StyledButton
                                href="https://eu1.hubs.ly/H08swyQ0"
                                style="default"
                                target="_blank"
                            >
                                Rozwijam brand
                            </StyledButton>
                        </Flex>
                        {/* --- */}
                        <Flex
                            direction={'column'}
                            justifyContent={'space-between'}
                            backgroundColor={'#EEE'}
                            px={{
                                base: 8,
                                md: 4,
                            }}
                            py={8}
                            minH={{ lg: '350px' }}
                            w={{
                                base: '100%',
                                lg: '24%',
                            }}
                        >
                            <Box>
                                <Text
                                    fontWeight={'600'}
                                    fontSize={'lg'}
                                    // borderBottom={'3px solid black'}
                                    position={'relative'}
                                    _after={{
                                        position: 'absolute',
                                        height: '3px',
                                        width: '40px',
                                        content: '""',
                                        bottom: '-10px',
                                        left: 0,
                                        background: 'black',
                                    }}
                                >
                                    Zacznij sprzedawać online
                                </Text>
                                <Text mt={8} mb={{ base: 6, lg: 0 }}>
                                    Umów się na niezobowiązującą rozmowę z naszym specjalistą
                                </Text>
                            </Box>
                            <StyledButton
                                href="https://eu1.hubs.ly/H08swyQ0"
                                style="default"
                                target="_blank"
                            >
                                Otwieram sklep
                            </StyledButton>
                        </Flex>
                        {/* --- */}
                        <Flex
                            direction={'column'}
                            justifyContent={'space-between'}
                            backgroundColor={'#EEE'}
                            px={{
                                base: 8,
                                md: 4,
                            }}
                            py={8}
                            minH={{ lg: '350px' }}
                            w={{
                                base: '100%',
                                lg: '24%',
                            }}
                        >
                            <Box>
                                <Text
                                    fontWeight={'600'}
                                    fontSize={'lg'}
                                    // borderBottom={'3px solid black'}
                                    position={'relative'}
                                    _after={{
                                        position: 'absolute',
                                        height: '3px',
                                        width: '40px',
                                        content: '""',
                                        bottom: '-10px',
                                        left: 0,
                                        background: 'black',
                                    }}
                                >
                                    Obsługuj marketplaces
                                </Text>
                                <Text mt={8} mb={{ base: 6, lg: 0 }}>
                                    Dowiedz się jak zwiększyć sprzedaż na marketplace dzięki IdoSell
                                </Text>
                            </Box>
                            <StyledButton
                                href="https://eu1.hubs.ly/H08swyQ0"
                                style="default"
                                target="_blank"
                            >
                                Rozwijam się
                            </StyledButton>
                        </Flex>
                    </Flex>
                </Flex>
                <TabsSection
                    py={20}
                    title="Poznaj najważniejsze funkcjonalności IdoSell"
                    subtitle="Naszą ideą jest maksymalizowanie sprzedaży naszych klientów, dlatego chcemy udostępniać najlepsze rozwiązania rynkowe"
                    tabsContent={[
                        {
                            tabTitle: 'Dedykowany, customowy wygląd sklepu',
                            tabName: 'Wygląd sklepu',
                            imgUrl: 'https://www.idosell.com/panel/file-gate.php?id=290615&ext=.webp',
                            list: [
                                {
                                    item: 'Gotowe szablony sklepu z możliwością pełnej personalizacji',
                                    href: 'https://www.idosell.com/pl/galeria-designow/',
                                },
                                {
                                    item: 'Możliwość przygotowania indywidualnego szablonu strony',
                                },
                                {
                                    item: 'Możliwość samodzielnego skomponowania własnego szablonu sklepu w narzędziu Composer',
                                },
                                {
                                    item: 'Moduł bloga i aktualności',
                                },
                                {
                                    item: 'Kolekcje i zestawy',
                                    href: 'https://www.idosell.com/pl/kolekcje-towarow/',
                                },
                                {
                                    item: 'Strefy rekomendacji produktów',
                                },
                                {
                                    item: 'Przyjazna i szybka wersja mobilna sklepu',
                                },
                            ],
                        },
                        {
                            tabTitle: 'Narzędzia z gwarancją skuteczności',
                            tabName: 'Sprzedaż',
                            imgUrl: 'https://www.idosell.com/panel/file-gate.php?id=290616&ext=.jpeg',
                            list: [
                                {
                                    item: 'Różne modele promocji: kody rabatowe, towary gratisowe, rabaty indywidulane, grupowe, progowe, kumulacyjne, oferty specjalne, karty podarunkowe i bony',
                                },
                                {
                                    item: 'Profesjonalne moduły reklamacji i zwrotów',
                                },
                                {
                                    item: 'Automatyzacja marketingu',
                                },
                                {
                                    item: 'Program lojalnościowy oraz partnerski',
                                },
                                {
                                    item: 'Narzędzia analityczne: Raporty i zestawienia sprzedaży',
                                },
                                {
                                    item: 'Aplikacja IdoSell POS do sprzedaży stacjonarnej',
                                },
                                {
                                    item: 'Moduł B2B',
                                },
                            ],
                        },
                        // {
                        //     tabTitle: 'Gotowe, aktualizowane przez nas integracje',
                        //     tabName: 'Integracje',
                        //     imgUrl: 'https://www.idosell.com/panel/file-gate.php?id=290618&ext=.webp',
                        //     list: [
                        //         {
                        //             item: 'Kurierzy',
                        //         },
                        //         {
                        //             item: 'Marketplaces',
                        //         },
                        //         {
                        //             item: 'Najpopularniejszed systemy ERP ',
                        //         },
                        //         {
                        //             item: 'Narzędzia Google (Analytics, Search Console, Tag Manager, Shopping)',
                        //         },
                        //         {
                        //             item: 'Social media (Instagram, Facebook)',
                        //         },
                        //         {
                        //             item: 'Porównywarki cen',
                        //         },
                        //         {
                        //             item: 'Systemy płatności',
                        //         },
                        //     ],
                        // },
                        {
                            tabTitle: 'Bezpieczeństwo, wsparcie i askepty prawne',
                            tabName: 'Bezpieczeństwo',
                            imgUrl: 'https://www.idosell.com/panel/file-gate.php?id=290620&ext=.webp',
                            list: [
                                {
                                    item: 'Pomoc techniczna dostępna 24/7',
                                },
                                {
                                    item: 'Dostęponość sklepów na poziomie 99,99% (SLA)',
                                },
                                {
                                    item: 'Gotowy regulamin sklepu zgodny z wymogami prawnymi',
                                },
                                {
                                    item: 'Zgoda na pliki cookies zgodna z prawem UE i RODO',
                                },
                                {
                                    item: 'Szablon sklepu zgodny z dyrektywą Omnibus',
                                },
                                {
                                    item: 'Pełna i zawsze aktualna wersja systemu',
                                },
                            ],
                        },
                        {
                            tabTitle: 'Zarządzanie klientami',
                            tabName: 'Klienci',
                            imgUrl: 'https://www.idosell.com/panel/file-gate.php?id=290617&ext=.webp',
                            list: [
                                {
                                    item: 'System CRM do zarządzania bazą klientów',
                                },
                                {
                                    item: 'Indywidualne i grupowe rabaty dla klientów',
                                },
                                {
                                    item: 'Automatyczne wystawianie i wysyłanie faktur',
                                },
                                {
                                    item: 'Moduł do zarządania opiniami',
                                },
                                {
                                    item: 'Strefa pytań i odpowiedzi (FAQ)',
                                },
                            ],
                        },
                        {
                            tabTitle: 'Magazyny',
                            tabName: 'Magazyny',
                            imgUrl: 'https://www.idosell.com/panel/file-gate.php?id=290619&ext=.webp',
                            list: [
                                {
                                    item: 'Wudowany system zarządzania magazynem (WMS)',
                                },
                                {
                                    item: 'Obsługa sprzedaży wielokanałowej (omnichannel)',
                                },
                                {
                                    item: 'Listy towarów do spakowania',
                                },
                                {
                                    item: 'Automatyzacja wydruku etykiet i przepływu zamówień',
                                },
                                {
                                    item: 'Integracja z Fulfilmentem',
                                },
                                {
                                    item: 'Obsługa sprzedaży w modelach dropshipping i cross-docking',
                                },
                            ],
                        },
                        {
                            tabTitle: 'Cross-border',
                            tabName: 'Cross-border',
                            imgUrl: 'https://www.idosell.com/panel/file-gate.php?id=298413&ext=.jpeg',
                            list: [
                                {
                                    item: 'Moduł tłumaczeń automatycznych',
                                },
                                {
                                    item: 'Lokalne metody płatności i wysyłki',
                                },
                                {
                                    item: 'Zgodność z wymogami UE',
                                },
                                {
                                    item: 'Moduł do automatycznego wyliczania stawek VAT OSS',
                                },
                                {
                                    item: 'Obsługa wielu wersji językowych oraz walut',
                                },
                                {
                                    item: 'Integracje z marketplaces i porównywarkami',
                                },
                            ],
                        },
                        {
                            tabTitle: 'Zwiększanie sprzedaży',
                            tabName: 'Zwiększanie sprzedaży',
                            imgUrl: 'https://www.idosell.com/panel/file-gate.php?id=290621&ext=.webp',
                            list: [
                                {
                                    item: 'Checkout 2.0 i wbudowany system płatności IdoPay',
                                },
                                {
                                    item: 'Reklamy Google od IdoSell',
                                },
                                {
                                    item: 'Moduł do sprzedaży subskrypcyjnej',
                                },
                                {
                                    item: 'Zaawansowana wyszukiwarka Searching Pro',
                                },
                                {
                                    item: 'Inteligentne rekomendacje produktowe IdoSell RS',
                                },
                                {
                                    item: 'Preferencyjne stawki kurierskie w IdoSell Broker',
                                },
                                {
                                    item: 'Darmowe dostawy dzięki usłudze Smile',
                                },
                            ],
                        },
                    ]}
                />
                <CarouselSectionWithImages
                    title="Gotowe, aktualizowane przez nas integracje"
                    subTitle="Korzystaj z najważniejszych i najpopularniejszych integracji wbudowanych w twój sklep internetowy"
                    sections={[
                        {
                            label: 'Systemy płatności',
                            items: [
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193322&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193242&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193114&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193332&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193323&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193334&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193333&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193321&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193256&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193243&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193250&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193249&ext=.svg',
                                    },
                                },
                            ],
                        },
                        {
                            label: 'Kurierzy',
                            items: [
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193105&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193254&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193110&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193117&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193102&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193104&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193255&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193119&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193253&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193251&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193252&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193107&ext=.svg',
                                    },
                                },
                            ],
                        },
                        {
                            label: 'Marketplaces, porównywarki cen',
                            items: [
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193136&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193092&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193099&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193674&ext=.png',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193145&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193147&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=246449&ext=.jpg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193134&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193150&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193240&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193134&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193148&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193122&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193149&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193091&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193135&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193675&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193093&ext=.svg',
                                    },
                                },
                            ],
                        },
                        {
                            label: 'Operatorzy fulfillment',
                            items: [
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193108&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193105&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193113&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193100&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193116&ext=.svg',
                                    },
                                },
                            ],
                        },
                        {
                            label: 'Certyfikaty',
                            items: [
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193127&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193118&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193123&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193137&ext=.svg',
                                    },
                                },
                            ],
                        },
                        {
                            label: 'Pozostali partnerzy',
                            items: [
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193112&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193106&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193109&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193096&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193103&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193125&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193101&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193676&ext=.png',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193111&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=242359&ext=.svg',
                                    },
                                },
                            ],
                        },
                    ]}
                />
                <MigrationSection
                    image={{
                        url: 'https://www.iai-system.com/panel/file-gate.php?id=300777&ext=.jpg',
                    }}
                    boxSide="right"
                    title="Wybierz sklep, z którym możesz łatwo sprzedawać za granicę"
                    subtitle="Ponad 20% transakcji w sklepach IdoSell to cross-border"
                    ctaButton={{
                        title: 'Rozpocznij sprzedaż międzynarodową',
                        href: 'https://www.idosell.com/pl/sprzedaz-miedzynarodowa/',
                        variant: 'default',
                    }}
                    position={'relative'}
                    _before={{
                        base: {
                            content: '""',
                            position: 'absolute',
                            height: '100%',
                            top: 0,
                            width: '100vw',
                            marginLeft: '50%',
                            left: '-50vw',
                            zIndex: -2,
                            backgroundColor: '#1AAC7A', // Replace with your theme color reference
                        },
                        lg: {
                            display: 'none',
                        },
                    }}
                >
                    <Text mb="30px">
                        Rozwiązania IdoSell ułatwią ci rozpoczęcie sprzedaży międzynarodowej i
                        wyjście z ofertą na nowe rynki. Sklep możesz w prosty sposób przetłumaczyć i
                        skonfigurować samodzielnie lub zlecić to naszym specjalistom. W IdoSell
                        wiemy wszystko o sprzedaży międzynarodowej.
                    </Text>
                </MigrationSection>
                <SectionWithPlusTick
                    // padding={'5rem 0'}
                    pt={'5rem'}
                    pb={{
                        base: 0,
                        lg: '6rem',
                    }}
                    gap={'50px'}
                    alignItems={'center'}
                    display={'flex'}
                    flexDirection={'column'}
                    background={'#1AAC7A'}
                    padding={'50px'}
                    title="Bezpieczeństwo twojego sklepu internetowego to dla nas priorytet"
                    subtitle="W IdoSell otrzymujesz najbezpieczniejszy system, żebyś mógł w pełni skupić się na sprzedaży"
                    image={{
                        url: 'https://www.idosell.com/panel/file-gate.php?id=301028&ext=.webp',
                        // url: 'https://www.idosell.com/panel/file-gate.php?id=300783&ext=.webp',
                        //TODO
                        alt: 'Zdjęcie pana z założonymi rękami',
                    }}
                    tickItem={[
                        {
                            title: 'Bezpieczeństwo 24/7',
                            text: 'Współpracujemy z Beyond.pl - najbezpieczniejszym centrum danych w Polsce i jednym z najbezpieczniejszych w Unii Europejskiej. W IdoSell dostajesz gotowy system i wsparcie najlepszych specjalistów, którzy całodobowo monitorują dostępność serwerów.',
                            link: {
                                url: 'https://www.idosell.com/pl/bezpieczenstwo/',
                                name: 'Dowiedz się więcej',
                            },
                        },
                        {
                            title: 'Profesjonalne wsparcie',
                            text: 'W IdoSell otrzymujesz dostęp do darmowych webinarów i materiałów edukacyjnych. Dodatkowo możesz bez ograniczeń korzystać z Centrum Supportu i skontaktować się z naszym działem wsparcia z poziomu przeglądarki poprzez połączenie wideo, głosowe lub tradycyjny komunikat.',
                            link: {
                                url: 'https://www.idosell.com/pl/unikalne-wsparcie-w-ramach-abonamentu/',
                                name: 'Dowiedz się więcej',
                            },
                        },
                    ]}
                />
                <SubscriptionSection
                    py={8}
                    title="Dobierz plan abonamentowy do swoich potrzeb"
                    subtitle="Naszą ideą jest maksymalizowanie sprzedaży naszych klientów, dlatego chcemy udostępniać najlepsze rozwiązania rynkowe."
                    subscriptionsInfo={[
                        {
                            name: 'Start',
                            text: 'Optymalny, żeby rozpocząć sprzedaż internetową',
                        },
                        {
                            name: 'Business',
                            text: 'Dostosowany dla średnich biznesów, żeby rozwinąć skrzydła',
                        },
                        {
                            name: 'Expert',
                            text: 'Jeszcze więcej możliwości dla średnich i dużych biznesów',
                        },
                        {
                            name: 'Enterprise',
                            text: 'Najlepszy dla dużych biznesów, żeby zwiększyć z nami sprzedaż',
                        },
                        {
                            name: 'Individual',
                            text: 'Dający wiele możliwości elastycznego dostosowania rozwiązań',
                        },
                    ]}
                />
                <Box
                    _before={{
                        content: '""',
                        position: 'absolute',
                        height: '100%',
                        top: 0,
                        width: '100vw',
                        marginLeft: '50%',
                        left: '-50vw',
                        zIndex: -2,
                        backgroundColor: 'rgba(238, 238, 238, 1)',
                    }}
                    position={'relative'}
                    mb={{
                        base: 6,
                        md: 10,
                    }}
                >
                    <ContentImage
                        title="Nie masz czasu na samodzielną konfigurację sklepu?"
                        image={{
                            url: 'https://www.idosell.com/panel/file-gate.php?id=302079&ext=.png',
                            alt: 'Zdjęcie sklepu klasyka',
                        }}
                        subtitle="Nasi eksperci we wszystkim ci pomogą"
                        ctaButton={{
                            title: 'Sprawdź pakiety wdrożeniowe',
                            href: 'https://www.idosell.com/pl/pakiety-wdrozeniowe/',
                            variant: 'default',
                        }}
                        layout_order="image_right"
                        padding="3rem 0 3rem 0"
                        bgColor="grey"
                        mt={10}
                        // pt={{
                        //     base: 10,
                        //     lg: 8,
                        // }}
                    >
                        <p>
                            Spersonalizujemy twój sklep i zintegrujemy potrzebne funkcje. Oferujemy
                            gotowe rozwiązanie, które pozwoli ci szybko rozpocząć sprzedaż online i
                            rozwinąć swój biznes.
                        </p>
                    </ContentImage>
                    <CaseStudySection
                        mt={8}
                        py={8}
                        pt={16}
                        title="Zaufało nam tysiące sprzedawców"
                        text="Zobacz inspirujące historie sklepów, które wybrały IdoSell i osiągnęły sukces w sprzedaży online.
Sprawdź, jak dołączyły do grona profesjonalistów i zaczęły sprzedawać więcej."
                        casestudies={[
                            {
                                image: {
                                    url: 'https://www.idosell.com/panel/file-gate.php?id=279666&ext=.jpeg',
                                    alt: 'Zdjęcie wyróżniające Ministerstwo Dobrego Mydła',
                                },
                                hastags: '#AllinOne',
                                title: 'Decyzja padła na IdoSell, który na ten moment dostarcza nam wszystkich potrzebnych funkcjonalności.',
                                link: {
                                    label: 'Ministerstwo Dobrego Mydła',
                                    href: 'https://www.idosell.com/pl/historie-klientow-idosell/ministerstwo-dobrego-mydla/',
                                    target: '_blank',
                                },
                            },
                            {
                                image: {
                                    url: 'https://www.idosell.com/panel/file-gate.php?id=298411&ext=.jpeg',
                                    alt: 'Zdjęcie wyróżniające Loki koki',
                                },
                                hastags: '#RekomendacjeProduktowe',
                                title: 'Wartość zamówień z rekomendacjami zwiększyła się o 25%. (...) co przełożyło się na 3% wzrost ogólnych przychodów.',
                                link: {
                                    label: 'Loki koki',
                                    href: 'https://www.idosell.com/pl/blog/wartosc-zamowien-wieksza-o-25-historia-sukcesu-sklepu-lokikoki-pl-1235328056',
                                    target: '_blank',
                                },
                            },
                            {
                                image: {
                                    url: 'https://www.idosell.com/panel/file-gate.php?id=318462&ext=.jpg',
                                    alt: 'Zdjęcie wyróżniające Poszetka',
                                },
                                hastags: '#Cross-border',
                                title: 'Budowa marki Poszetka również za granicą była naturalnym krokiem już we wczesnych fazach rozwoju. Pierwsze zamówienia za granicę pojawiły się już w 2015 roku.',
                                link: {
                                    label: 'Poszetka',
                                    href: 'https://www.idosell.com/pl/historie-klientow-idosell/poszetka-twist-w-modzie-klasycznej/',
                                    target: '_blank',
                                },
                            },
                        ]}
                        bgColor="white"
                    />
                </Box>
                <ContactSection pb={1} mb={14} />
            </div>
        </ThemeProvider>
    );
}
